export function SidebarLogo(): JSX.Element {
  return (
    <div className="flex p-3 pt-0 items-center gap-1 self-stretch sticky top-0 bg-surface-0 z-50">
      <img
        src="/bc_logo.svg"
        alt="BeautifulCode"
        className="w-42 h-8 flex-shrink-0"
      />
    </div>
  );
}
